module.exports = __webpack_public_path__ + "img/icon-canal-facil.a648acc0.png";